import { type Dayjs } from "dayjs"

import { type InstitutionFilter } from "@/graphql/types"
import PresenceListQuery from "@/graphql/childrenPresence/PresenceList.gql"
import type { PresenceListResult } from "@/store/childrenPresence"
import { apolloClient } from "@/vue-apollo"

export async function fetchPresences(variables: {
  context: InstitutionFilter
  from: string
  to: string
}) {
  const { context, from, to } = variables
  if (!context || !from || !to) return []

  try {
    const { data } = await apolloClient.query<PresenceListResult>({
      query: PresenceListQuery,
      variables,
    })
    return data?.presences ?? []
  } catch {
    return []
  }
}

export async function fetchMonthOfPresences(context: InstitutionFilter, month: Dayjs) {
  const from = month.startOf("month").format("YYYY-MM-DD")
  const to = month.endOf("month").format("YYYY-MM-DD")

  return fetchPresences({ context, from, to })
}
